export enum DataScienceFeatures {
  DDA = 'DDA',
  HybridImpressions = 'HybridImpressions'
}
